module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAWBAMAAAD6A0vjAAAAGFBMVEVMksRMksRMksRMksRMksRMksRMksRMksRCsggqAAAAB3RSTlO79B6/uvMfGYQZbwAAAB9JREFUCNdjUAlRYGAvN2AQLy9gKKcMg8wAm6UgkAAAiZQaYThFypwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_blue.png
// module id = 1pHq
// module chunks = 0